import MuiClickable from "components/MuiExtras/MuiClickable";
import MuiReverse from "components/MuiExtras/Typography/MuiReverse";
import ApprovalStatusName from "components/Translations/ApprovalStatusName";
import { ApprovalStatus } from "models/ApiEnums";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import WorkFlowDrawer from "views/Timeline/Dialogs/WorkFlowDrawer";

/////////////////////////////////////////////////////////////////////////////////////

const ApprovalStatusLine: React.FC<{ feedItem: FeedItemDto; }> = ({ feedItem: { publicationId, publication } }) => {

    const [open, setOpen] = React.useState(false);

    return (publication.approvalStatus == ApprovalStatus.Pending || publication.approvalStatus == ApprovalStatus.PendingCognitiveAnalysis || publication.approvalStatus == ApprovalStatus.Rejected)
        ? (
            <>
                {
                    publication.approvalStatus == ApprovalStatus.Pending || publication.approvalStatus == ApprovalStatus.PendingCognitiveAnalysis
                        ? (
                            <MuiReverse color="warning" flat>
                                <ApprovalStatusName approvalStatus={publication.approvalStatus} />
                            </MuiReverse>
                        )
                        : (
                            <MuiClickable onClick={() => setOpen(true)}>
                                <MuiReverse color="error" flat>
                                    <ApprovalStatusName approvalStatus={publication.approvalStatus} />
                                </MuiReverse>
                            </MuiClickable>
                        )
                }

                {
                    open &&
                    <WorkFlowDrawer
                        publicationId={publicationId}
                        onClose={() => setOpen(false)}
                    />
                }
            </>
        )
        : null;
};

export default ApprovalStatusLine;